module.exports = __webpack_public_path__ + "6a055e71fd63a6abcc1648aad58899a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-in-the-house/Bedroom2.jpg
// module id = 3361
// module chunks = 0